<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content" style="margin-top: 20px;">
        <el-row>
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="运营商名称">
              <el-input v-model="searchCondition.name" placeholder="输入运营商名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="负责人姓名">
              <el-input v-model="searchCondition.legal_person" placeholder="输入负责人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="负责人手机号">
              <el-input v-model="searchCondition.legal_phone" placeholder="输入负责人手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <div style="text-align: right;margin: 5px 0;">
          <!-- v-permission:issue_add -->
          <el-button v-permission="`OperManagement_list_add`" type="primary" @click="addOperator('add')">添加运营商</el-button>
        </div>
        <ApeTable v-permission="`OperManagement_list_list`" ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus"
          :pagingData="pagingData" highlight-current-row @switchPaging="switchPaging">
          <el-table-column width="300" align="center" label="操作">
            <template slot-scope="scope">
              <!-- v-permission:issue_configure -->
              <el-button size="mini" type="text" @click="editOperatorInfo(scope.row.id)">运营商详情</el-button>
              <el-button size="mini" type="text" @click="toCustomerDetails(scope.row.id)">客户详情</el-button>
              <el-button v-permission="`OperManagement_list_cancel`" size="mini" type="text" @click="cancelShip(scope.row.id, '1')">取消资格</el-button>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <!-- 创建弹框 -->
    <ModalDialog :dialogData="operatorSetDialogData" @dialogConfirm="operatorSetConfirm" @dialogClose="settingClose">
      <template slot="content">
        <el-form :model="fromData" :rules="fromDatas" ref="fromData" label-position="right" label-width="120px">
          <el-form-item label="公司名称" prop="name">
            <el-input type="text" v-model="fromData.name" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="企业税号" prop="taxpayer">
            <el-input v-model="fromData.taxpayer" placeholder="请输入企业税号"></el-input>
          </el-form-item>
          <el-form-item label="负责人姓名" prop="legal_person">
            <el-input type="text" v-model="fromData.legal_person" placeholder="请输入负责人姓名"></el-input>
          </el-form-item>
          <el-form-item label="负责人手机号" prop="legal_phone">
            <el-input v-model="fromData.legal_phone" type="number" placeholder="请输入负责人手机号"></el-input>
          </el-form-item>
          <el-form-item label="营业执照" prop="business_license">
            <uploadRechargeImg :imageUrl="fromData.business_license" @handleSuccess='RechargImgSuccess($event,"business_license")'
              @handleRemove='RechargImgRemove($event,"business_license")' :ossData='ossData' :ossObj="ossObj" class="upload-item">
            </uploadRechargeImg>
          </el-form-item>
          <el-form-item label="启用状态" prop="status">
            <el-switch v-model="fromData.status" :active-value="1" :inactive-value="2" active-text="开启"
              inactive-text="关闭">
            </el-switch>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
  import uploadRechargeImg from '@/components/uploadRechargeImg.vue'
  import PageHeaderLayout from "@/layouts/PageHeaderLayout";
  import ModalDialog from '@/components/ModalDialog'
  import ApeTable from "@/components/ApeTable";
  import {
    mapGetters
  } from 'vuex'
  export default {
    components: {
      uploadRechargeImg,
      PageHeaderLayout,
      ApeTable,
      ModalDialog,
    },
    data() {
      return {
        updateType: 'add',
        ossData: {},
        ossObj: {},
        not_select: false,
        type: 0,
        id: '',
        formButtonArr: [{
          label: '确定',
          type: 'primary',
          flag: 'add'
        }],
        is_show_form: false,
        loadingStaus: false,
        corp_type: '1',
        tabsList: [{
            label: '人资公司',
            name: '1'
          },
          {
            label: '用工企业',
            name: '2'
          },
        ],
        // 分页信息
        pagingData: {
          is_show: true,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0
        },
        dataList: [],
        columns: [{
            title: "公司名称",
            value: "name",
            header_align: "center",
            align: "center",
          },
          {
            title: "负责人姓名",
            value: "legal_person",
            header_align: "center",
            align: "center",
          },
          {
            title: "负责人手机号",
            value: "legal_phone",
            header_align: "center",
            align: "center",
          },
          {
            title: "添加时间",
            value: "created_at",
            header_align: "center",
            align: "center",
          },
        ],
        searchCondition: {
          name: '',
          legal_person: '',
          legal_phone: ''
        },
        operatorSetDialogData: {
          visible: false,
          title: '添加运营商',
          width: '50%',
          loading: false,
          modal: false
        },
        fromDatas: {
          name: [{
            required: true,
            message: '公司名称不能为空',
            trigger: 'blur'
          }],
          taxpayer: [{
            required: true,
            message: '企业税号不能为空',
            trigger: 'blur'
          }, ],
          legal_person: [{
            required: true,
            message: '负责人姓名不能为空',
            trigger: 'blur'
          }, ],
          legal_phone: [{
            required: true,
            message: '负责人手机号不能为空',
            trigger: 'blur'
          }, ],
          status: [{
            required: true,
            message: '企业状态必选',
            trigger: 'blur'
          }, ]
        },
        fromData: {
          business_license: ''
        },
        // 分页的offset,序号列使用
        offset: 0,
        // 已上传文件列表
        uploadFileList: [],
        // 附件列表
        attachmentList: [],
      };
    },
    watch: {},
    methods: {
      cancelShip(arg, val) {
        this.$confirm('点击“确认”后，运营商信息将被清空，请仔细确认后在操作', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.cancelShipFun(arg, val)
        }).catch(() => {

        })
      },
      // 取消资格
      async cancelShipFun(id) {
        var res = await this.$api.deleteSupplierInfo(id)
        this.$nextTick(() => {
          if (res) {
            this.$message.success('取消成功!')
            this.init()
          }
        })

      },
      //移除
      RechargImgRemove(url, param) {
        if (param == 'business_license') {
          this.fromData.business_license = ''
          return false
        }
      },
      //成功
      RechargImgSuccess(url, param) {
        if (param == 'business_license') {
          this.fromData.business_license = url
          return false
        }
      },
      async ossUpload() {
        const res_oss = await this.$api.getOss({
          dir: 'ph/hr/'
        })
        if (res_oss) {
          this.ossObj = res_oss
          this.ossData = {
            ossAccessKeyId: res_oss.accessid,
            policy: res_oss.policy,
            signature: res_oss.signature
          }
        } else {
          this.$message.error('获取oss签名失败')
        }
      },
      async addOperator() {
        this.updateType = 'add';
        this.fromData = {
          status:1
        }
        await this.ossUpload()
        this.operatorSetDialogData.visible = true;
        this.operatorSetDialogData.title = '添加运营商';
      },
      // 创建e签宝数据
      async editOperatorInfo(id) {
        this.updateType = 'edit';
        this.operatorSetDialogData.title = '编辑运营商';
        let data = await this.$api.getSupplierInfo(id)
        this.fromData = {
          id:data.id,
          name: data.name,
          taxpayer:data.taxpayer ? data.taxpayer : '',
          legal_person: data.legal_person ? data.legal_person : '',
          legal_phone: data.legal_phone ? data.legal_phone : '',
          status: data.status ? data.status : 2,
          business_license: data.business_license ? data.business_license : '',
        }
        await this.ossUpload()
        this.operatorSetDialogData.visible = true
      },
      // E签宝处理模态框，关闭事件
      settingClose() {
        this.operatorSetDialogData.visible = false
        this.fromData = {}
      },
      // E签宝处理模态框，确定事件
      operatorSetConfirm() {
        this.$refs["fromData"].validate((valid) => {
          if (valid) {
            var that = this;
            that.operatorSetDialogData.loading = true;
            that.submitCreateOperator();
            setTimeout(function() { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
              that.operatorSetDialogData.loading = false;
            }, 3000)
          } else {
            this.$message.warning('请先正确填写信息');
            return false;
          }
        });

      },
      // 创建e签宝数据提交
      async submitCreateOperator() {
        let res = {}
        if (this.updateType == 'add') {
          res = await this.$api.createSupplier(this.fromData)
        } else {
          res = await this.$api.editSupplier(this.fromData.id, this.fromData)
        }
        if (res) {
          this.$message.success('操作成功。')
          this.operatorSetDialogData.loading = false;
          this.operatorSetDialogData.visible = false
          this.fromData = {}
          this.init()
        } else {
          this.$message.error('创建失败。')
        }
        return false;
      },
      // 公司详情
      toCustomerDetails(id) {
        if (!id) return;
        this.$router.push({
          path: "operator/customer_details",
          query: {
            id: id
          }
        })
      },
      // 重置分页
      async resetPage() {
        this.$refs.apeTable.currentPage = 1
      },
      // 切换页码操作
      async switchPaging() {
        this.init();
      },
      // 搜索
      searchButton() {
        this.resetPage()
        this.init('search')
      },
      //获取列表
      async init(type) {
        this.loadingStaus = true
        let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
        let searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, pagingInfo)
        this.dataList = []
        let {
          data,
          pages
        } = await this.$api.getSupplierList(searchCondition)
        this.$nextTick(() => {
          this.dataList = data || []
        })
        this.pagingData.total = pages?.total || 0
        this.offset = pages?.offset || 0
        this.loadingStaus = false
      },
      // 处理搜索条件
      handleSearchCondition() {
        let condition = {}
        if (this.searchCondition.name) {
          condition.name = this.searchCondition.name
        }

        if (this.searchCondition.legal_person) {
          condition.legal_person = this.searchCondition.legal_person
        }

        if (this.searchCondition.legal_phone) {
          condition.legal_phone = this.searchCondition.legal_phone
        }

        return condition
      }
    },
    computed: {
      ...mapGetters(['userPermissions'])
    },
    mounted() {
      this.resetPage()
      this.init();
    },
  };
</script>

<style lang="scss" scoped>

</style>
